import createAuthenticatedPageLogger from "./authenticated-page";
import createRefreshTokenLogger from "./refresh-token";
import createAuthCodeLogger from "./auth-code";
export default function createAuthenticationLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `auth:${input.type}` });
    return {
        accountIdReceived(accountId, sender) {
            return log({
                type: "account-id-received",
                details: { accountId, sender },
            });
        },
        refreshToken: createRefreshTokenLogger(log),
        authCode: createAuthCodeLogger(log),
        authenticatedPage: createAuthenticatedPageLogger(log),
    };
}
